import React from 'react';
import _ from 'lodash';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';

export function LoginBanner(props) {
	const block = 'c-login-banner';
	
	const { loginBanner, onClickActions } = props;
	const {text, links} = loginBanner;

	function handleOnClick (link) {
        const onClickAction = _.find(link.dataAttributes, {key:'onClickAction'})
        let onClickFunction = _.noop();

        if (onClickAction?.value) {
            onClickFunction = onClickActions[onClickAction.value]
        }
        onClickFunction(link);
	}

	function renderButtons() {
		const markup = _.isEmpty(links) ? null : 
			<div className={`${block}__action-panel-ctas`}>
				{ links.map((link) => 
					<div className={`${block}__button dark-theme`} key={`${block}-${link.id}`}>
						<Button {...{
							id: `${link.id}`,
							label : link.label,
							gtmLabel : CORE_GTM_TRACKING_VALUES.label[link.id] || '',
							gtmComponentName : CORE_GTM_TRACKING_VALUES.componentName.loginBanner,
							gtmComponentGroup : CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
							mobileLabel : link.mobileLabel,
							testId : `${link.id}`,
							type: link.type.toLowerCase(),
							onClickCallback : () => {
								handleOnClick(link)
							}, 
						}}/>
					</div>
				)}
			</div>
		
		return markup
	}

	return <section className={`${block}`}>
		<div className={`${block}__action-panel`}>
			<p>{text}</p>
			{renderButtons()}
		</div>
		
	</section>
}
